"use strict";

exports.__esModule = true;
exports.default = getBodyScrollbarWidth;
/**
 * Get the width of the vertical window scrollbar if it's visible
 */
function getBodyScrollbarWidth() {
  var ownerDocument = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var window = ownerDocument.defaultView;
  return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}